import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import openStudios from "./open_studios.png";
import summerFlyer from "./SummerOpenCall2026_Flyer-Final.jpg";
import nearFiction from "./near_fiction.png";

const exhibits = [
  {
    title: "Art, Film, & Visual Studies: Open Studios 2025",
    image: openStudios,
    venue: "Carpenter Center, Cambridge, MA",
    date: "May 2, 2025",
    year: "2025",
  },
  {
    title: "Near Fiction",
    image: nearFiction,
    venue: "Rebecca Molayem Gallery, Los Angeles",
    date: "July 25, 2026",
    link: "/exhibits/near-fiction",
    year: "2026",
  },
  {
    title: "Summer Show",
    image: summerFlyer,
    venue: "Francis Gallery, Los Angeles",
    date: "July 22 – September 12, 2026",
    link: "/exhibits/francis-gallery-summer-show",
    year: "2026",
  },
];

function Exhibits() {
  const grouped = exhibits.reduce((acc, ex) => {
    (acc[ex.year] = acc[ex.year] || []).push(ex);
    return acc;
  }, {});
  const years = Object.keys(grouped).sort((a, b) => b - a);

  return (
    <Container className="art-section">
      <div className="exhibits-page">
        {years.map((year) => (
          <section key={year}>
            <h2 className="art-year-heading">{year}</h2>
            <div className="exhibits-grid">
            {grouped[year].map((ex, i) => (
              <div key={i} className="exhibit-item">
                {ex.image && ex.link && ex.link.startsWith("/") ? (
                  <Link to={ex.link}><img src={ex.image} alt={ex.title} className="exhibit-img" /></Link>
                ) : ex.image ? (
                  <img src={ex.image} alt={ex.title} className="exhibit-img" />
                ) : null}
                <p className="exhibit-title">
                  {ex.link && ex.link.startsWith("/") ? (
                    <Link to={ex.link}>{ex.title}</Link>
                  ) : ex.link ? (
                    <a href={ex.link} target="_blank" rel="noopener noreferrer">{ex.title}</a>
                  ) : (
                    ex.title
                  )}
                </p>
                {ex.venue && <p className="exhibit-meta">{ex.venue}</p>}
                {ex.date && <p className="exhibit-meta">{ex.date}</p>}
              </div>
            ))}
            </div>
          </section>
        ))}
      </div>
    </Container>
  );
}

export default Exhibits;
